import axios from 'axios';
const auth = axios.create({ baseURL : 'https://v1-csapi.compsoft.com.br:10104' });
//const auth = axios.create({ baseURL : 'http://localhost:9008'});
export default auth;